module.exports = __webpack_public_path__ + "img/edu-1.520a8283.png";